<script setup>
import OddsmatcherSettings from "@/components/oddsmatcher/OddsmatcherSettings.vue";
import OddsmatcherOptions from "@/components/oddsmatcher/OddsmatcherOptions.vue";
import {useMatchedBetStore} from "@/stores/MatchedBetStore";
import {onMounted, ref} from "vue";
import {useRoute, useRouter} from "vue-router";
import OddsmatcherFilterAndTable from "@/components/oddsmatcher/OddsmatcherFilterAndTable.vue";

const route = useRoute();
const router = useRouter();

const matchedBetStore = useMatchedBetStore()

onMounted(async () => {
  const query = route.query;
  if (query.type) matchedBetStore.backBetData.type = query.type;
  if (query.stake) matchedBetStore.backBetData.stake = query.stake;
  if (query['loss-value']) matchedBetStore.backBetData.outcome = query['loss-value'];
  if (query['min-odds']) matchedBetStore.oddsmatcherData.minOdds = query['min-odds'];
  if (query.bookie) matchedBetStore.oddsmatcherData.bookie = query.bookie;
  await router.replace({query: {}});
});

const activeView = ref('advanced');
</script>

<template>
  <div :class="{'simple-flex': activeView === 'simple'}" style="margin-top: 2rem">
    <div :class="{'simple-container': activeView === 'simple'}">
      <div style="display: flex; justify-content: center;">
        <button @click="activeView = 'simple'"
                :class="{'active': activeView === 'simple'}"
                class="toggle-button">Simple View
        </button>
        <button @click="activeView = 'advanced'"
                :class="{'active': activeView === 'advanced'}"
                class="toggle-button">Advanced View
        </button>
      </div>
      <template v-if="activeView === 'simple'">
        <oddsmatcher-settings/>
        <oddsmatcher-options/>
      </template>

      <oddsmatcher-filter-and-table v-else/>
    </div>
  </div>

</template>


<style scoped>
.simple-flex {
  display: flex;
  justify-content: center;
  width: 100%
}

.simple-container {
  max-width: 576px;
}

.toggle-button {
  padding: 10px 20px;
  background-color: #f0f0f0;
  border: 1px solid #ddd;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.toggle-button:hover {
  background-color: var(--clr-primary-40);
}

.toggle-button.active {
  background-color: var(--clr-primary-100);
  color: white;
}
</style>